<mat-toolbar class="subtitulo">Relatórios - Departamento Pessoal</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-label>Selecione o tipo do relatório</mat-label>
                    <mat-select required
                                [(ngModel)]="tipoRelatorioSelecionado" 
                                name="tipoRelatorioSelecionado">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of tiposRelatorios" [value]="d">
                            {{d.descricao.toUpperCase()}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="tipoRelatorioSelecionado">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                    <mat-form-field fxFlex= "200px" fxLayoutGap="20px" fxFlexOffset="20px">
                        <input matInput name= "dataInicio"
                                [matDatepicker]="dataInicio" 
                                placeholder="Data início" 
                                [(ngModel)]="filtro.dataInicio"
                                (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicio></mat-datepicker>
                    </mat-form-field>
                
                    <mat-form-field fxFlex= "200px" >
                        <input matInput name="dataFim"
                                [matDatepicker]="dataFim" 
                                placeholder="Data fim" 
                                [(ngModel)]="filtro.dataFim"
                                (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                        <mat-datepicker #dataFim></mat-datepicker>
                    </mat-form-field>

                    <div ngModelGroup="comboBeneficiario" fxFlex="50" fxLayoutGap="20px">
                        <combo-funcionario [showDisplayId]="false" 
                                           [selecionado]="filtro.funcionario"
                                           [desabilitado]="false"
                                           (valorChange)="onValorChangeFuncionario($event)">
                        </combo-funcionario>
                    </div> 
                    
                    <div ngModelGroup="cbDepartamento" fxFlex="50" fxFlexOffset="20px">
                        <combo-pesquisavel #comboDepartamento
                                           nome="departamento" 
                                           [itens]="comboDepartamentos" 
                                           itemDescricao="nmDepartamento"
                                           itemId="idDepartamento"
                                           [showDisplayId]="false" 
                                           placeholder="Departamento"
                                           [obrigatorio]="false"
                                           [(valor)]="filtro.departamento">
                        </combo-pesquisavel>
                    </div>

                </div>
    
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxFlexFill> 
                    <div ngModelGroup="cbUnidade" fxFlex="33" fxFlexOffset="20px">
                        <combo-pesquisavel #comboUnidade 
                                           nome="unidade" 
                                           [itens]="comboUnidades" 
                                           itemDescricao="nomeUnidade"
                                           itemId="id"
                                           [showDisplayId]="false" 
                                           placeholder="Unidade"
                                           [obrigatorio]="false"
                                           [(valor)]="filtro.unidade">
                        </combo-pesquisavel>
                    </div>

                    <div ngModelGroup="cbFuncoes" fxFlex="33" fxFlexOffset="20px">
                        <combo-pesquisavel #comboFuncao
                                           nome="funcao" 
                                           [itens]="comboFuncoes" 
                                           itemDescricao="nome"
                                           itemId="id"
                                           [showDisplayId]="false" 
                                           placeholder="Função"
                                           [obrigatorio]="false"
                                           [(valor)]="filtro.funcao">
                        </combo-pesquisavel>
                    </div>

                    <div ngModelGroup="cbCargos" fxFlex="33" fxFlexOffset="20px">
                        <combo-pesquisavel #comboCargo 
                                           nome="cargo" 
                                           [itens]="comboCargos" 
                                           itemDescricao="nome"
                                           itemId="id"
                                           [showDisplayId]="false" 
                                           placeholder="Cargo"
                                           [obrigatorio]="false"
                                           [(valor)]="filtro.cargo">
                        </combo-pesquisavel>
                    </div>

                </div>
    
                <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                    <button mat-raised-button fxFlex="150px" (click)="getRelatorio(MIMETYPE_PDF)" 
                            [ngStyle]="{'background-color' : formulario.valid ? 'green' : ''}" 
                            style="color: white;" 
                            [fxHide]="!mostrarTabela"
                            [disabled]="formulario.invalid">
                        GERAR PDF
                    </button>
    
                    <button mat-raised-button fxFlex="150px" 
                            (click)="getRelatorio(MIMETYPE_EXCEL)" 
                            [ngStyle]="{'background-color' : formulario.valid ? 'green' : ''}" 
                            style="color: white;" 
                            [fxHide]="!mostrarTabela"
                            [disabled]="formulario.invalid">
                        GERAR EXCEL
                    </button>
    
                    <button mat-raised-button fxFlex="150px" (click)="consultar()" 
                            [disabled]="formulario.invalid">
                        CONSULTAR
                    </button>
    
                    <button mat-raised-button fxFlex="150px" style="padding-right: 20px" (click)="limpar()">
                        LIMPAR
                    </button>
                </div>
            </div>

        </form>



        <div [hidden]="!mostrarTabela" style="margin-top: 20px;">
            <mat-paginator #paginator [pageSizeOptions]="[50, 100, 150, 200, 300]" showFirstLastButtons></mat-paginator>
        </div>
        <table [fxHide]="!mostrarTabela" 
                matSort matSortDisableClear mat-table [dataSource]="dataSource">
                
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef style="width: 20px">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? selection.toggle(row) : null"
                                  [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="colaborador" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Colaborador</th>
                <td mat-cell *matCellDef="let element"> {{element.nomeCobaborador }} </td>
            </ng-container>

            <ng-container matColumnDef="email" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">E-mail</th>
                <td mat-cell *matCellDef="let element"> {{element.email }} </td>
            </ng-container>

            <ng-container matColumnDef="unidade">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Unidade</th>
                <td mat-cell *matCellDef="let element"> {{element.unidade }} </td>
            </ng-container>

            <ng-container matColumnDef="departamento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Departamento</th>
                <td mat-cell *matCellDef="let element"> {{element.departamento }} </td>
            </ng-container>

            <ng-container matColumnDef="cargo">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Cargo</th>
                <td mat-cell *matCellDef="let element"> {{element.cargo }} </td>
            </ng-container>            

            <ng-container matColumnDef="funcao">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Funcao</th>
                <td mat-cell *matCellDef="let element"> {{element.funcao }} </td>
            </ng-container>            

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row);"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator (page)="handlePageBottom($event)" 
                            [pageSize]="paginator.pageSize"
                            [pageIndex]="paginator.pageIndex" 
                            [length]="paginator.length"
                            [pageSizeOptions]="paginator.pageSizeOptions">
            </mat-paginator>
        </div>        
        <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px"
                [fxHide]="mostrarTabela" >
            {{msg}}
        </div>       

    </div>
</div>




